import { NewCustomerOutDto, NewCustomerInDto } from '../../../types/customer.dto'

export const NEW_CUSTOMER = 'NEW_CUSTOMER'
export const NEW_CUSTOMER_SUCCESS = 'NEW_CUSTOMER_SUCCESS'
export const NEW_CUSTOMER_ERROR = 'NEW_CUSTOMER_ERROR'
export const RESET_NEW_CUSTOMER = 'RESET_NEW_CUSTOMER'

export interface NewCustomer {
  type: typeof NEW_CUSTOMER
  payload: NewCustomerOutDto
}

export interface NewCustomerSuccess {
  type: typeof NEW_CUSTOMER_SUCCESS
  payload: NewCustomerInDto
}

export interface NewCustomerError {
  type: typeof NEW_CUSTOMER_ERROR
  payload: string | boolean
}

export interface ResetNewCustomer {
  type: typeof RESET_NEW_CUSTOMER
  payload: null
}

export interface State {
  data: NewCustomerInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = NewCustomer | NewCustomerSuccess | NewCustomerError | ResetNewCustomer
